import { motion } from 'framer-motion';
import styled from 'styled-components';

export const MotionButton = styled(motion.button)`
  padding: 1rem 2rem;
  background: linear-gradient(45deg, #FF5722, #FF7043);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(255, 87, 34, 0.3);
`; 